import { useState, useEffect, useMemo, useCallback } from 'react';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import useWorkflowTypeOptions from 'automation-ui-enrollment/components/workflowType/hooks/useWorkflowTypeOptions';
export default function useWorkflowTypePQLs({
  objectTypeFilter
} = {}) {
  var _lockedOption$upgrade;
  const [lockedOption, setLockedOption] = useState();
  const {
    openUpgradeModal
  } = useUpgradeModal((_lockedOption$upgrade = lockedOption === null || lockedOption === void 0 ? void 0 : lockedOption.upgradeModalKey) !== null && _lockedOption$upgrade !== void 0 ? _lockedOption$upgrade : '', !!lockedOption);
  useEffect(() => {
    if (lockedOption !== null && lockedOption !== void 0 && lockedOption.upgradeModalKey) {
      openUpgradeModal();
      setLockedOption(undefined);
    }
  }, [lockedOption, openUpgradeModal]);
  const {
    loading,
    options
  } = useWorkflowTypeOptions({
    objectTypeFilter
  });
  const optionByObjectTypeId = useMemo(() => new Map(options.map(option => [option.value, option])), [options]);
  const isLocked = useCallback(objectTypeId => {
    var _optionByObjectTypeId, _optionByObjectTypeId2;
    return (_optionByObjectTypeId = (_optionByObjectTypeId2 = optionByObjectTypeId.get(objectTypeId)) === null || _optionByObjectTypeId2 === void 0 ? void 0 : _optionByObjectTypeId2.locked) !== null && _optionByObjectTypeId !== void 0 ? _optionByObjectTypeId : false;
  }, [optionByObjectTypeId]);
  const shouldSelectObjectType = useCallback(objectTypeId => {
    const selectedOption = optionByObjectTypeId.get(objectTypeId);
    if (selectedOption !== null && selectedOption !== void 0 && selectedOption.locked) {
      setLockedOption(selectedOption);
      return false;
    } else {
      setLockedOption(undefined);
      return true;
    }
  }, [optionByObjectTypeId]);
  return {
    loading,
    options,
    isLocked,
    shouldSelectObjectType,
    CustomModal: lockedOption === null || lockedOption === void 0 ? void 0 : lockedOption.CustomModal,
    onCloseCustomModal: () => setLockedOption(undefined)
  };
}